import { customElement } from 'lit/decorators.js'
import { html, LitElement, type CSSResultGroup, nothing } from 'lit'
import { consume } from '@lit/context'
import { style } from './configurator-step.style.js'
import { StepDataDTO } from 'components/ordering/configurator/api/dtos/step-data-dto.js'
import { StepSelectionData } from 'components/ordering/configurator/api/dtos/step-selection-data.js'
import { ProductOptionDTO } from 'components/ordering/configurator/api/dtos/option-dtos.js'
import { is } from 'typia'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { updateStepSelectionContext } from 'components/ordering/configurator/components/context/context-definition.js'

@customElement('csc-configurator-step')
export class CSCConfiguratorStep extends LitElement {
  static override styles?: CSSResultGroup = [hostStyle, style]

  step: StepDataDTO

  @consume({ context: updateStepSelectionContext })
  updateStepSelection!: (stepKey: string, stepData: StepSelectionData) => void

  constructor({ step }: { step: StepDataDTO }) {
    super()
    this.step = step
  }

  get stepKey() {
    return `step-${this.step.id}`
  }

  override render() {
    if (!is<ProductOptionDTO[]>(this.step.options1)) return nothing

    return html`
      <div>
        StepName: ${this.step.name}
        <cse-group>
          ${(this.step.options1).map((option) => {
            const state = option.selected ? 'selected' : option.selectable ? 'selectable' : 'disabled'
            return html`
              <cse-selectable
                variant="secondary"
                state="${state}"
                @click=${() => { this.updateStepSelection(this.stepKey, { selection: [option.id] }) /* selectable state -> loading */ }}>
                ${option.name}
              </cse-selectable>
            `
          })}
        </cse-group>
      </div>
    `
  }
}
